import dayjs from "dayjs";

/**
 * @param {import("../../types/Year").Year | import("../../types/Configuration").ConfigurationCurrentYear} year
 * @returns {string}
 */
export function getYearLabel(year) {
  const yearFrom = dayjs(year.from);
  const yearTo = dayjs(year.to);
  if (yearFrom.year() !== yearTo.year()) {
    return `${yearFrom.year()} - ${yearTo.year()}`;
  } else if (yearFrom.month() !== yearTo.month()) {
    const format = "MM/YYYY";
    return `${yearFrom.format(format)} - ${yearTo.format(format)}`;
  }
  return yearFrom.format("DD/MM/YYYY");
}
